import Header, { MrtHeaderProps } from './entries/MrtHeader';
import Footer, { MrtFooterProps } from './entries/MrtFooter';
import { BadgeStyle, LocalNavVerticalItem, VerticalItem } from './constants/lnb';
import GlobalSearch from './shared/components/GlobalSearch';
import LayoutProvider from './providers/LayoutProvider';
import useGetPlaceholder from './shared/components/GlobalSearch/hooks/apis/useGetPlaceholder';
import getSigninDeepLink from './shared/utils/getSigninDeepLink';

export { Header, Footer, GlobalSearch, LayoutProvider, useGetPlaceholder, getSigninDeepLink };

export type { MrtHeaderProps, MrtFooterProps, BadgeStyle, LocalNavVerticalItem, VerticalItem };
